import { getUrl } from "../../getUrl";
import { NavigateFunction } from "react-router";
import { useAuth } from "../auth";
import { isProd } from "../../isProd";

const AGROMANAGER_PARAMS = {
  // When (if?) Agromanager makes a dev url available these params should be changed to:
  // subDomain: isProd ? "" : "beta",
  // clientId: isProd ? "aurea_imaging_prod" : "aurea_imaging_beta",
  subDomain: isProd ? "" : "",
  clientId: isProd ? "aurea-imaging-prod" : "aurea-imaging-prod",
  redirectUrl: isProd
    ? "https://app.aureaimaging.com"
    : "https://app.dev.aureaimaging.com",
};

export function getAgroManagerUrl() {
  const { subDomain, clientId, redirectUrl } = AGROMANAGER_PARAMS;
  return `https://sso.${subDomain}agromanager.eu/v8.0/client/connect?clientId=${clientId}&redirectUrl=${redirectUrl}/agromanager_sso_callback`;
}

export async function AgroManagerIdentityHandler(
  agroManagerCode: string,
  navigate: NavigateFunction,
) {
  const res = await fetch(getUrl(`v1/auth/agromanager/verify/`), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      code: agroManagerCode,
    }),
  });

  if (res.status < 300) {
    const data = await res.json();
    const userRes = await fetch(getUrl("v1/user/me"), {
      headers: {
        Authorization: `Bearer ${data.access_token}`,
      },
    });

    let email = "";
    if (userRes.ok) {
      const userData = await userRes.json();
      email = userData.email;
    } else {
      const payload = JSON.parse(atob(data.access_token.split(".")[1]));
      email = payload.id;
    }

    useAuth.getState().setTokens(data, email);
    await useAuth.persist.rehydrate();
    await new Promise((resolve) => setTimeout(resolve, 50));

    const existingEnvironment = await fetchCurrentEnvironment();

    if (existingEnvironment) {
      useAuth.getState().setAgroManagerEnv(existingEnvironment);
      navigate("/");
    } else {
      window.location.href = getAgroManagerUrl();
    }
  } else {
    navigate(`/login`, { state: { error: "flash.AgroManagerUserNotFound" } });
  }
}

export async function AgroManagerEnvironmentHandler(
  agroManagerCode: string,
  agroManagerEnvironment: string,
  navigate: NavigateFunction,
) {
  await useAuth.persist.rehydrate();

  const token = await useAuth.getState().getToken();
  if (!token) {
    navigate(`/login`, { state: { error: "flash.AgroManagerUserNotFound" } });
    return;
  }

  const res = await fetch(getUrl(`v1/user/me/agromanager_user`), {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      token: agroManagerCode,
      current_environment_name: agroManagerEnvironment,
    }),
  });

  if (res.status < 300) {
    navigate("/");
  } else {
    throw new Error(`Agromanager service responded with ${res.status}`);
  }
}

export async function fetchCurrentEnvironment() {
  const token = await useAuth.getState().getToken();
  if (!token) return null;

  try {
    const res = await fetch(getUrl("/v1/user/me/agromanager_user/"), {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.current_environment_name;
  } catch {
    return null;
  }
}
